import React from 'react';

export default function TrashCanIcon() {
  return (
    <span role="img" aria-label="">🗑</span>
  );
}
